import React from 'react';
import { AccountStorageSection } from '../../../../../App/components/AccountStorageSection';
import { useBackupActions } from '../hooks/useBackupActions';
import './FilesPane.css';

const FilesPane = () => {
  const {
    fileInputRef,
    exportStatus,
    importStatus,
    setImportStatus,
    handleExport,
    handleImportClick,
    handleFileSelected,
    handleImportConfirm,
  } = useBackupActions();

  return (
    <>
      <section className="settings-modal__section">
        <h3 className="settings-modal__section-title">Storage</h3>
        <div className="settings-modal__setting">
          <AccountStorageSection />
        </div>
      </section>

      <section className="settings-modal__section">
        <h3 className="settings-modal__section-title">Backup</h3>

        <div className="settings-modal__setting settings-modal__setting--row-actions">
          <div className="settings-modal__setting-text">
            <label className="settings-modal__label">Export backup</label>
            <p className="settings-modal__description">
              Download all your campaigns, templates, settings, and views as a JSON file
            </p>
          </div>
          <button
            className="settings-modal__action-btn"
            type="button"
            onClick={handleExport}
            disabled={exportStatus === 'loading'}
          >
            {exportStatus === 'loading' ? 'Exporting...'
              : exportStatus === 'done' ? 'Downloaded!'
              : exportStatus === 'error' ? 'Export failed'
              : 'Export'}
          </button>
        </div>

        <div className="settings-modal__setting">
          <div className="settings-modal__setting-text">
            <label className="settings-modal__label">Import backup</label>
            <p className="settings-modal__description">
              Restore from a previously exported JSON file (overwrites matching items)
            </p>
          </div>
          <input
            ref={fileInputRef}
            type="file"
            accept=".json"
            onChange={handleFileSelected}
            style={{ display: 'none' }}
          />
          {importStatus?.confirm ? (
            <div className="settings-modal__import-confirm">
              <span className="settings-modal__import-file">{importStatus.file}</span>
              <span className="settings-modal__import-count">{importStatus.data.itemCount} items</span>
              <button
                type="button"
                className="settings-modal__action-btn settings-modal__action-btn--danger"
                onClick={handleImportConfirm}
              >
                Confirm import
              </button>
              <button
                type="button"
                className="settings-modal__action-btn settings-modal__action-btn--ghost"
                onClick={() => setImportStatus(null)}
              >
                Cancel
              </button>
            </div>
          ) : (
            <button
              type="button"
              className="settings-modal__action-btn"
              onClick={handleImportClick}
              disabled={importStatus === 'loading'}
            >
              {importStatus === 'loading' ? 'Importing...'
                : importStatus === 'done' ? 'Imported!'
                : importStatus === 'error' ? 'Import failed'
                : 'Import'}
            </button>
          )}
        </div>
      </section>
    </>
  );
};

export default FilesPane;
